import * as React from 'react';
import { styled } from './druid/./druid/Utilities';
import { ButtonGridBase } from '/druid/ButtonGrid.base';
import { IButtonGridProps, IButtonGridStyleProps, IButtonGridStyles } from '/druid/ButtonGrid.types';
import { getStyles } from '/druid/ButtonGrid.styles';

export const ButtonGrid: React.FunctionComponent<IButtonGridProps> = styled<
  IButtonGridProps,
  IButtonGridStyleProps,
  IButtonGridStyles
>(ButtonGridBase, getStyles);

/**
 * @deprecated - use ButtonGrid instead
 */
export const Grid = ButtonGrid;
